{
    "metadata_editor": {
        "add_category": "Add category",
        "add_category_prompt": "Enter the category name",
        "add_choice": "Add choice",
        "add_field": "Add field",
        "allow_multiple_docs": "Allow multiple selections",
        "app_hidden_description": "Hide the field from user facing apps, while continue displaying it in backstage.",
        "app_hidden_fields": "Hidden in user apps",
        "can_not_delete_category": "Category deletion restricted",
        "can_not_delete_category_text": "This category cannot be deleted because it contains fields you are not allowed to remove (identified by a lock icon next to the field name). Please move these fields to another category before attempting to delete.",
        "carbon_copy": "Use as CC email",
        "carbon_copy_description": "By adding an additional email address to receive copies of your event communications, you acknowledge that you are sharing your event-related information with that person. Depending on the features enabled, they may also be able to access or act on your behalf in connection with the event.",
        "carbon_copy_tip": "This will allow attendees or event organisers to add an additional email address which will receive copies of all emails sent to the attendee. The CC recipient will have full access to the emails and can take actions in the email such as clicking on magic links, responding to event invitations, unsubscribe etc.",
        "carbon_copy_tooltip": "By adding an additional email address to receive copies of event communications, you acknowledge that you are sharing the main attendee's event-related information with that person. Depending on the features enabled, they may also be able to access or act on the attendee’s behalf in connection with the event.",
        "category": "Category",
        "choice_list": "choice list",
        "choice_list_details": {
          "alert": {
            "link": "targeting and choice values",
            "message": "The text before the brackets are the labels displayed in the app, this can be updated any time. The text in brackets are called keys. If you have already applied targeting DO NOT update the keys. Translation keys are not shown here, but can be viewed in the translation manager. More info about",
            "title": "Targeting and choice values important notes"
          }
        },
        "datetime_config": {
            "dates": "Set specific range",
            "dates_range": "dates range",
            "enable_dates": "Date picker",
            "enable_times": "Time picker",
            "format": "Date format",
            "keep_timezone": "Keep original data timezone",
            "keep_timezone_hint": "<b>This setting only affects integration data and has no effect on SpotMe registration page</b><br/>Set this toggle to true if this field is intended to map specific integration data that is coming in ISO format (e.g. 2026-12-24T10:32:01Z ) and this data should not be shifted to the SpotMe Event timezone",
            "time_format": "Time format",
            "time_range": "time range",
            "title": "Configure the date and time pickers"
        },
        "default": "Default",
        "default_value": "Backstage preview & default value",
        "delete_category": "Delete category",
        "delete_category_success": "Category deleted successfully",
        "delete_category_text": "Are you sure you want to delete this category? All the metadata inside this category will be deleted as well",
        "delete_field": "Delete field",
        "description": "Description",
        "description_hint": "App only",
        "drag_field": "Drag field handler",
        "edit_choice_list": "Edit",
        "edit_options": "Edit options",
        "ensure_referential_integrity": "Check references",
        "enter_category_name": "Type a name for the category",
        "errors": {
            "fetch_fail": "Failed to fetch appropriate metadata"
        },
        "false": "false",
        "field_controls": {
            "less": "Show less",
            "more": "Show more"
        },
        "field_kind": "Field kind",
        "field_may_not_be_private": "The following fields may not be private: {0}.",
        "field_name": "Field name",
        "field_name_tooltip": "Spaces and special characters are not allowed, except underscores, which cannot be the first character",
        "fields": "Fields",
        "fields_hidden": "Editing {0}'s metadata is forbidden",
        "fields_hidden_admin": "Editing {0}'s metadata is forbidden for normal users.",
        "fields_hidden_admin_text": "This operation is normally forbidden and can have unpredictable consequences. Are you sure you want to continue?",
        "fields_limit_info": "Fields limit: {0} of {1}",
        "fields_limit_reached": "You have reached the limit of {0} fields. If you need more, please open a support request.",
        "general_warning": {
            "knowledge_base": "Knowledge base",
            "line_1": "This tool can make irreversible changes to the way data is structured in this event instance.",
            "line_2": "Be careful! Learn more about the metadata manager in our "
        },
        "has_been_modified": "Metadata have been updated while you were working on them. Please take note of your changes and refresh the page",
        "invalid_data": "Invalid data",
        "invalid_field_name": "Invalid field name: {0}|Invalid field names: {0}",
        "is_required": "Is required",
        "label": "Label",
        "label_and_tooltip": "Field label & description",
        "metadata": "metadata",
        "move_down": "Move down",
        "move_to_top": "Move on top",
        "move_up": "Move up",
        "no_category": "Base data",
        "no_default_value": "No default value",
        "no_fields_in_category": "There are no fields in this category",
        "no_options_of_type": "There are no {0}s to choose from",
        "ok": "Ok",
        "placeholder": "Placeholder",
        "placeholder_hint": "Backstage only",
        "private": "Private",
        "private_tip": "If enabled this field will be visible to other participants only after contact request is accepted.",
        "remove": "Remove",
        "representation": {
            "_representation": "First line",
            "_representation_image": "Image",
            "_representation_line2": "Second line",
            "_representation_line3": "Third line",
            "description": "Representation labels describe how items of this type are named in the UI. Words wrapped in {0} and {1} will be replaced with field values."
        },
        "restore": "Restore",
        "save_changes": "Save changes",
        "save_success": "Your changes have been successfully saved",
        "titles": {
            "page": "Metadata Manager",
            "representation": "Representation"
        },
        "tooltip": "Tooltip",
        "tooltip_hint": "Backstage only",
        "true": "true",
        "unknown_save_error": "An unknown error occured.",
        "value": "Value",
        "write_protected": "Prevent in app modification"
    }
}
